import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
import { useIsKenya, getPhoneDisplay } from '../hooks/useIsKenya';
function HeroArtwork() {
  return <motion.svg viewBox="0 0 400 300" className="w-full h-full max-h-[280px]" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    delay: 0.2
  }} data-id="element-1509">
      {/* Large circle - stroke only */}
      <circle cx="200" cy="150" r="120" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.12" data-id="element-1510" />
      <circle cx="200" cy="150" r="80" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1511" />
      <circle cx="200" cy="150" r="40" fill="#FF6600" opacity="0.04" data-id="element-1512" />

      {/* Arc segments */}
      <path d="M 80 150 A 120 120 0 0 1 200 30" fill="none" stroke="#FF6600" strokeWidth="2" opacity="0.15" data-id="element-1513" />
      <path d="M 320 150 A 120 120 0 0 1 200 270" fill="none" stroke="#FF6600" strokeWidth="2" opacity="0.15" data-id="element-1514" />

      {/* Grid lines */}
      <line x1="50" y1="150" x2="350" y2="150" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1515" />
      <line x1="200" y1="20" x2="200" y2="280" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1516" />

      {/* Diagonal lines */}
      <line x1="80" y1="50" x2="320" y2="250" stroke="#FF6600" strokeWidth="0.5" opacity="0.06" data-id="element-1517" />
      <line x1="320" y1="50" x2="80" y2="250" stroke="#FF6600" strokeWidth="0.5" opacity="0.06" data-id="element-1518" />

      {/* Scattered dots */}
      <circle cx="120" cy="80" r="3" fill="#FF6600" opacity="0.18" data-id="element-1519" />
      <circle cx="280" cy="220" r="3" fill="#FF6600" opacity="0.18" data-id="element-1520" />
      <circle cx="300" cy="80" r="2" fill="#FF6600" opacity="0.12" data-id="element-1521" />
      <circle cx="100" cy="200" r="2" fill="#FF6600" opacity="0.12" data-id="element-1522" />
      <circle cx="200" cy="150" r="4" fill="#FF6600" opacity="0.2" data-id="element-1523" />

      {/* Small accent circles */}
      <circle cx="140" cy="120" r="15" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1524" />
      <circle cx="260" cy="180" r="15" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1525" />

      {/* Blue accent - subtle */}
      <circle cx="240" cy="100" r="6" fill="#00316B" opacity="0.12" data-id="element-1526" />
    </motion.svg>;
}
function SidebarArtwork() {
  return <motion.svg viewBox="0 0 100 500" className="w-full h-auto" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.4
  }} data-id="element-1527">
      {/* Vertical line */}
      <line x1="50" y1="0" x2="50" y2="500" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1528" />

      {/* Stacked circles */}
      <circle cx="50" cy="60" r="40" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1529" />
      <circle cx="50" cy="60" r="25" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1530" />
      <circle cx="50" cy="60" r="4" fill="#FF6600" opacity="0.15" data-id="element-1531" />

      <circle cx="50" cy="180" r="30" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1532" />
      <circle cx="50" cy="180" r="15" fill="#FF6600" opacity="0.04" data-id="element-1533" />

      <circle cx="50" cy="280" r="35" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1534" />
      <circle cx="50" cy="280" r="20" fill="none" stroke="#FF6600" strokeWidth="0.5" opacity="0.08" data-id="element-1535" />

      <circle cx="50" cy="380" r="25" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-1536" />
      <circle cx="50" cy="380" r="3" fill="#FF6600" opacity="0.15" data-id="element-1537" />

      {/* Horizontal accent lines */}
      <line x1="20" y1="120" x2="80" y2="120" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1538" />
      <line x1="30" y1="230" x2="70" y2="230" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1539" />
      <line x1="25" y1="330" x2="75" y2="330" stroke="#FF6600" strokeWidth="0.5" opacity="0.1" data-id="element-1540" />

      {/* Small dots */}
      <circle cx="30" cy="140" r="2" fill="#FF6600" opacity="0.12" data-id="element-1541" />
      <circle cx="70" cy="260" r="2" fill="#FF6600" opacity="0.12" data-id="element-1542" />
      <circle cx="35" cy="350" r="2" fill="#FF6600" opacity="0.12" data-id="element-1543" />

      {/* Blue accent */}
      <circle cx="50" cy="450" r="20" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-1544" />
      <circle cx="50" cy="450" r="3" fill="#00316B" opacity="0.15" data-id="element-1545" />
    </motion.svg>;
}
export function TermsPage() {
  const isKenya = useIsKenya();
  const phoneDisplay = getPhoneDisplay(isKenya);
  const sections = [{
    number: '1',
    title: 'Introduction',
    content: <p data-id="element-1546">
          Welcome to Belo Digital. By accessing or using our website, products,
          or services, you agree to be bound by these Terms & Conditions. If you
          do not agree, please refrain from using our services.
        </p>
  }, {
    number: '2',
    title: 'Services',
    content: <>
          <p className="mb-4" data-id="element-1547">
            Belo Digital provides digital solutions including but not limited
            to:
          </p>
          <ul className="space-y-3" data-id="element-1548">
            <li className="flex items-start text-lg" data-id="element-1549">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1550" />
              Software & digital systems development
            </li>
            <li className="flex items-start text-lg" data-id="element-1551">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1552" />
              IT consulting & advisory
            </li>
            <li className="flex items-start text-lg" data-id="element-1553">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1554" />
              Digital infrastructure & integrations
            </li>
            <li className="flex items-start text-lg" data-id="element-1555">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1556" />
              Data & technology solutions
            </li>
          </ul>
          <p className="mt-4" data-id="element-1557">
            Specific service details may be governed by separate agreements or
            contracts.
          </p>
        </>
  }, {
    number: '3',
    title: 'Use of Website',
    content: <>
          <p className="mb-4" data-id="element-1558">
            You agree to use our website lawfully and not to:
          </p>
          <ul className="space-y-3" data-id="element-1559">
            <li className="flex items-start text-lg" data-id="element-1560">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1561" />
              Engage in fraudulent or harmful activities
            </li>
            <li className="flex items-start text-lg" data-id="element-1562">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1563" />
              Attempt unauthorized access to systems
            </li>
            <li className="flex items-start text-lg" data-id="element-1564">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1565" />
              Distribute malicious software or code
            </li>
            <li className="flex items-start text-lg" data-id="element-1566">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1567" />
              Violate applicable laws or regulations
            </li>
          </ul>
        </>
  }, {
    number: '4',
    title: 'Intellectual Property',
    content: <p data-id="element-1568">
          All content, designs, software, trademarks, and materials on this
          website belong to Belo Digital unless stated otherwise. Unauthorized
          reproduction or use is prohibited.
        </p>
  }, {
    number: '5',
    title: 'Client Responsibilities',
    content: <>
          <p className="mb-4" data-id="element-1569">Clients agree to:</p>
          <ul className="space-y-3" data-id="element-1570">
            <li className="flex items-start text-lg" data-id="element-1571">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1572" />
              Provide accurate and lawful information
            </li>
            <li className="flex items-start text-lg" data-id="element-1573">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1574" />
              Maintain confidentiality of credentials
            </li>
            <li className="flex items-start text-lg" data-id="element-1575">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1576" />
              Use delivered solutions responsibly
            </li>
            <li className="flex items-start text-lg" data-id="element-1577">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2.5 mr-3 shrink-0" data-id="element-1578" />
              Comply with applicable laws
            </li>
          </ul>
        </>
  }, {
    number: '6',
    title: 'Limitation of Liability',
    content: <p data-id="element-1579">
          Belo Digital shall not be liable for indirect, incidental, or
          consequential damages arising from use of our website or services,
          except where required by law.
        </p>
  }, {
    number: '7',
    title: 'Confidentiality',
    content: <p data-id="element-1580">
          We respect confidentiality of client information. Both parties may be
          bound by separate Non-Disclosure Agreements where applicable.
        </p>
  }, {
    number: '8',
    title: 'Termination',
    content: <p data-id="element-1581">
          We reserve the right to suspend or terminate access to services where
          misuse, unlawful activity, or breach of terms occurs.
        </p>
  }, {
    number: '9',
    title: 'Governing Law',
    content: <p data-id="element-1582">These Terms are governed by the laws of the Republic of Kenya.</p>
  }, {
    number: '10',
    title: 'Changes to Terms',
    content: <p data-id="element-1583">
          We may update these Terms from time to time. Continued use of services
          constitutes acceptance of revised Terms.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-1584">
          <p data-id="element-1585">For questions regarding these Terms:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-1586">Belo Digital</p>
          <p data-id="element-1587">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1588">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-1589">
            Phone:{' '}
            <a href="tel:+254701660306" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-1590">
              {phoneDisplay}
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-1591">
      <Section background="default" data-id="element-1592">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1593">
          <div data-id="element-1594">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-sm font-semibold text-[#FF6600] uppercase tracking-wider mb-4" data-id="element-1595">
              Legal
            </motion.p>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.05
          }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-1596">
              Terms & Conditions
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-gray-500 text-base" data-id="element-1597">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </motion.p>
          </div>
          <div className="hidden lg:flex items-center justify-center" data-id="element-1598">
            <HeroArtwork data-id="element-1599" />
          </div>
        </div>
      </Section>

      <Section background="white" data-id="element-1600">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1601">
          {/* Main content */}
          <div className="lg:col-span-9" data-id="element-1602">
            <div className="space-y-14" data-id="element-1603">
              {sections.map((section, index) => <motion.div key={section.number} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.04
            }} className="border-b border-gray-100 pb-14 last:border-0" data-id="element-1604">
                  <div className="flex items-start gap-4 mb-5" data-id="element-1605">
                    <span className="text-sm font-bold text-[#FF6600] bg-[#FF6600]/10 px-3 py-1.5 rounded mt-0.5 shrink-0" data-id="element-1606">
                      {section.number.padStart(2, '0')}
                    </span>
                    <h2 className="text-2xl font-bold font-heading text-[#0C0C0C]" data-id="element-1607">
                      {section.title}
                    </h2>
                  </div>
                  <div className="ml-14 text-gray-600 leading-relaxed text-lg" data-id="element-1608">
                    {section.content}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Decorative sidebar */}
          <div className="hidden lg:block lg:col-span-3" data-id="element-1609">
            <div className="sticky top-32" data-id="element-1610">
              <SidebarArtwork data-id="element-1611" />
            </div>
          </div>
        </div>
      </Section>
    </main>;
}